import { Button, Result } from '@sinohealth/butterfly-ui-components';
import React, { useEffect, useState } from 'react';
import styles from './index.less';

type ResetResultProps = {
  backLogin?: () => void;
};

/** 重置成功 */
const ResetResult: React.FC<ResetResultProps> = (props) => {
  const { backLogin } = props;
  const [countdownm, setCountdown] = useState(5);

  useEffect(() => {
    const interval = setInterval(() => {
      setCountdown((n) => n - 1);
    }, 1000);
    return () => {
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    if (countdownm <= 0) {
      backLogin && backLogin();
    }
  }, [countdownm]);

  return (
    <div className={styles['reset-result']}>
      <Result
        status="success"
        title="密码重置成功"
        style={{ padding: 0 }}
        subTitle={`${countdownm}s 后自动跳转登录页`}
        extra={[
          <Button
            className={styles['custom-btn']}
            type="primary"
            key="console"
            block
            size="large"
            onClick={backLogin}
          >
            立即登录
          </Button>,
        ]}
      />
    </div>
  );
};

export default ResetResult;
